import { Route, Routes } from "react-router-dom";
import { Landing } from "./Landing/Landing";
import { MailingAddress } from "./MailingAddress/MailingAddress";
import { ResidentialAddress } from "./ResidentialAddress/ResidentialAddress";
import { UpdateEmail } from "./UpdateEmail";

export const ManagePersonalDetailsRoutes = () => (
  <Routes>
    <Route path="/" element={<Landing />} />
    <Route path="/residential-address" element={<ResidentialAddress />} />
    <Route path="/mailing-address" element={<MailingAddress />} />
    <Route path="/update-email" element={<UpdateEmail />} />
  </Routes>
);
